
import {Component, Vue} from 'vue-property-decorator';
import {
	UIStore,
	PushService,
	SessionStore,
	LocationService,
	CustomerProfileStore
} from '@customer-portal/shared';
import PermissionModal from './PermissionModal.vue';
import {Platform} from 'quasar';

@Component({
	components: {
		PermissionModal,
	}
})
export default class PermissionsWrapper extends Vue {
	get brandConfig() {
		return SessionStore.brandConfig;
	}

	get brandName() {
		return SessionStore.brandConfig?.brandName || '';
	}

	get showPushNotificationRequest() {
		return UIStore.showPushNotificationRequest;
	}

	set showPushNotificationRequest(value: boolean) {
		UIStore.setShowPushNotificationRequest(value);
	}

	get showPushNotificationDisabled() {
		return UIStore.showPushNotificationDisabled;
	}

	set showPushNotificationDisabled(value: boolean) {
		UIStore.setShowPushNotificationDisabled(value);
	}

	get showGeolocationRequest() {
		return UIStore.showGeolocationRequest;
	}

	set showGeolocationRequest(value: boolean) {
		UIStore.setShowGeolocationRequest(value);
	}

	get showGeolocationDisabled() {
		return UIStore.showGeolocationDisabled;
	}

	set showGeolocationDisabled(value: boolean) {
		UIStore.setShowGeolocationDisabled(value);
	}

	get isCapacitor() {
		return Platform.is.capacitor as boolean;
	}

	async requestPushNotification() {
		await PushService.requestPermission();
		this.showPushNotificationRequest = false;
	}

	openPushSettings() {
		PushService.openPushNotificationSettings();
	}

	openGeolocationSettings() {
		LocationService.openLocationSettings();
	}

	refreshProfile() {
		CustomerProfileStore.fetchProfile();
	}

	requestGeolocation() {
		LocationService.requestGeolocation();
	}
}
